import { render, staticRenderFns } from "./PartnersPage.vue?vue&type=template&id=cffc41be&scoped=true"
import script from "./PartnersPage.vue?vue&type=script&lang=js"
export * from "./PartnersPage.vue?vue&type=script&lang=js"
import style0 from "./PartnersPage.vue?vue&type=style&index=0&id=cffc41be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffc41be",
  null
  
)

export default component.exports